import {SODeleteSimpleAttribute} from '../../core/simple-attribute/so-delete-simple-attribute';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteSimpleAttribute extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteSimpleAttribute;
}